export default "__VITE_ASSET__d5214405__"